// Vita Nova — interacciones propias (vanilla, sin dependencias externas)

function vnInitReveals() {
  var els = document.querySelectorAll('.vn-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('vn-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('vn-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function vnInitGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-vn-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-vn-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-vn-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        principal.src = full;
        thumbs.forEach(function (t) { t.classList.remove('vn-pp__miniatura--activa'); });
        thumb.classList.add('vn-pp__miniatura--activa');
      });
    });
  });
}

function vnInitSelectorVariantes() {
  var forms = document.querySelectorAll('[data-vn-form]');
  forms.forEach(function (form) {
    var script = form.querySelector('[data-vn-variantes]');
    if (!script) return;

    var variantes;
    try {
      variantes = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var pastillas = form.querySelectorAll('[data-vn-opcion]');
    var inputId = form.querySelector('[data-vn-variant-id]');
    var seccion = form.closest('.vn-pp') || form.closest('[data-vn-scope]');
    var mapaImagenes = null;
    var mapaScript = form.querySelector('[data-vn-imagenes]');
    if (mapaScript) {
      try { mapaImagenes = JSON.parse(mapaScript.textContent); } catch (e) { mapaImagenes = null; }
    }
    var precioEl = seccion ? seccion.querySelector('[data-vn-precio]') : form.querySelector('[data-vn-precio]');
    var precioTachadoEl = seccion ? seccion.querySelector('[data-vn-precio-tachado]') : form.querySelector('[data-vn-precio-tachado]');
    var boton = form.querySelector('[data-vn-boton-comprar]');
    var botonTexto = form.querySelector('[data-vn-boton-texto]');
    var imagenPrincipal = seccion ? seccion.querySelector('[data-vn-galeria-principal]') : null;
    if (!pastillas.length || !inputId) return;

    var seleccion = {};
    pastillas.forEach(function (p) {
      if (p.classList.contains('vn-pp__pastilla--activa')) {
        seleccion[p.getAttribute('data-vn-opcion')] = p.getAttribute('data-vn-valor');
      }
    });

    function formatoMoneda(centavos) {
      var decimales = centavos % 100 === 0 ? 0 : 2;
      return '$' + (centavos / 100).toLocaleString('es-AR', { minimumFractionDigits: decimales, maximumFractionDigits: decimales });
    }

    function actualizar() {
      var variante = variantes.find(function (v) {
        return Object.keys(seleccion).every(function (pos) {
          return v['option' + pos] === seleccion[pos];
        });
      });
      if (!variante) return;

      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatoMoneda(variante.price);
      if (precioTachadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachadoEl.textContent = formatoMoneda(variante.compare_at_price);
          precioTachadoEl.hidden = false;
        } else {
          precioTachadoEl.hidden = true;
        }
      }
      if (boton) {
        boton.disabled = !variante.available;
        if (botonTexto) {
          botonTexto.textContent = variante.available
            ? botonTexto.getAttribute('data-texto-disponible') || botonTexto.textContent
            : botonTexto.getAttribute('data-texto-agotado') || botonTexto.textContent;
        }
      }
      if (imagenPrincipal && mapaImagenes) {
        var nueva = mapaImagenes[variante.option1];
        if (nueva && imagenPrincipal.getAttribute('src') !== nueva) {
          imagenPrincipal.classList.add('vn-cambiando');
          var precarga = new Image();
          precarga.onload = precarga.onerror = function () {
            imagenPrincipal.src = nueva;
            imagenPrincipal.classList.remove('vn-cambiando');
          };
          precarga.src = nueva;
        }
      } else if (imagenPrincipal && variante.featured_image && variante.featured_image.src) {
        imagenPrincipal.src = variante.featured_image.src;
        if (variante.featured_image.alt) imagenPrincipal.alt = variante.featured_image.alt;
      }
    }

    pastillas.forEach(function (pastilla) {
      pastilla.addEventListener('click', function () {
        var opcion = pastilla.getAttribute('data-vn-opcion');
        var valor = pastilla.getAttribute('data-vn-valor');
        seleccion[opcion] = valor;
        form.querySelectorAll('[data-vn-opcion="' + opcion + '"]').forEach(function (p) {
          p.classList.remove('vn-pp__pastilla--activa');
        });
        pastilla.classList.add('vn-pp__pastilla--activa');
        actualizar();
      });
    });
  });
}

function vnInitZoomProducto() {
  var galerias = document.querySelectorAll('[data-vn-galeria]');
  galerias.forEach(function (galeria) {
    var abrirBtn = galeria.querySelector('[data-vn-zoom-abrir]');
    var seccion = galeria.closest('.vn-pp');
    var overlay = seccion ? seccion.querySelector('[data-vn-zoom]') : null;
    if (!abrirBtn || !overlay) return;

    var imgOverlay = overlay.querySelector('[data-vn-zoom-img]');
    var cerrarBtn = overlay.querySelector('[data-vn-zoom-cerrar]');

    function abrir() {
      var principal = galeria.querySelector('[data-vn-galeria-principal]');
      if (!principal) return;
      var src = principal.src.replace(/width=\d+/, 'width=2000');
      imgOverlay.src = src;
      imgOverlay.alt = principal.alt || '';
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.setAttribute('data-vn-zoom-abierto', '');
      });
      document.body.style.overflow = 'hidden';
    }

    function cerrar() {
      overlay.removeAttribute('data-vn-zoom-abierto');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        overlay.hidden = true;
      }, 250);
    }

    abrirBtn.addEventListener('click', abrir);
    cerrarBtn.addEventListener('click', cerrar);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) cerrar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) cerrar();
    });
  });
}

/* ---------- Preguntas frecuentes: abrir y cerrar respuestas con animación suave ---------- */
function vnInitFaq() {
  document.querySelectorAll('.vn-faq__item').forEach(function (item) {
    var pregunta = item.querySelector('summary');
    var respuesta = item.querySelector('.vn-faq__respuesta');
    if (!pregunta || !respuesta || !respuesta.animate) return;
    pregunta.addEventListener('click', function (e) {
      e.preventDefault();
      if (item._vnAnim) item._vnAnim.cancel();
      if (!item.open || item.classList.contains('is-cerrando')) {
        item.classList.remove('is-cerrando');
        item.open = true;
        item._vnAnim = respuesta.animate(
          [{ height: '0px', opacity: 0 }, { height: respuesta.scrollHeight + 'px', opacity: 1 }],
          { duration: 420, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' }
        );
      } else {
        item.classList.add('is-cerrando');
        item._vnAnim = respuesta.animate(
          [{ height: respuesta.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: 320, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        item._vnAnim.onfinish = function () { item.open = false; item.classList.remove('is-cerrando'); };
      }
    });
  });
}

/* ---------- Pop-up de bienvenida ----------
   Se abre solo una vez (al cerrarlo no se reabre solo por 14 días). Mientras no se suscriba,
   queda la burbuja "$5.000 OFF" abajo para volver a abrirlo; al suscribirse, desaparece todo.
   Tras el envío, Shopify recarga con #VnPopupForm y el pop-up se reabre con el código. */
function vnInitPopup() {
  var popup = document.querySelector('[data-vn-popup]');
  if (!popup) return;
  var burbuja = document.querySelector('[data-vn-popup-burbuja]');
  var CLAVE = 'vnPopupBienvenida';
  var leer = function () { try { return JSON.parse(localStorage.getItem(CLAVE) || 'null'); } catch (e) { return null; } };
  var guardar = function (v) { try { localStorage.setItem(CLAVE, JSON.stringify(v)); } catch (e) {} };
  var mostrarBurbuja = function (si) {
    if (!burbuja) return;
    if (si) { burbuja.hidden = false; requestAnimationFrame(function () { burbuja.classList.add('is-visible'); }); }
    else { burbuja.classList.remove('is-visible'); burbuja.hidden = true; }
  };

  var abrir = function () {
    mostrarBurbuja(false);
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-abierto'); });
    document.documentElement.classList.add('vn-sin-scroll');
  };
  var cerrar = function () {
    popup.classList.remove('is-abierto');
    document.documentElement.classList.remove('vn-sin-scroll');
    setTimeout(function () { popup.hidden = true; }, 350);
    var estado = leer();
    if (estado && estado.suscripto) return;
    guardar({ cerrado: Date.now() });
    setTimeout(function () { mostrarBurbuja(true); }, 400);
  };

  if (burbuja) {
    burbuja.querySelector('[data-vn-popup-burbuja-abrir]').addEventListener('click', abrir);
    // La X saca la burbuja por el mismo plazo que el pop-up cerrado (14 días)
    burbuja.querySelector('[data-vn-popup-burbuja-quitar]').addEventListener('click', function () {
      var e = leer() || {};
      guardar({ cerrado: e.cerrado || Date.now(), sinBurbuja: true });
      mostrarBurbuja(false);
    });
  }

  popup.querySelectorAll('[data-vn-popup-cerrar]').forEach(function (el) { el.addEventListener('click', cerrar); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) cerrar(); });

  var copiar = popup.querySelector('[data-vn-copiar]');
  if (copiar) {
    copiar.addEventListener('click', function () {
      var texto = copiar.querySelector('[data-vn-copiar-texto]');
      (navigator.clipboard ? navigator.clipboard.writeText(copiar.dataset.vnCopiar) : Promise.reject())
        .then(function () { texto.textContent = 'Copiado'; })
        .catch(function () { texto.textContent = copiar.dataset.vnCopiar; });
    });
  }

  // Volvió del envío del formulario: mostrar el resultado (código o error)
  if (location.hash === '#VnPopupForm') {
    if (popup.querySelector('[data-vn-popup-exito]')) guardar({ suscripto: true });
    abrir();
    return;
  }

  var estado = leer();
  if (estado && estado.suscripto) return;
  if (estado && estado.cerrado && Date.now() - estado.cerrado < 14 * 24 * 3600 * 1000) {
    if (!estado.sinBurbuja) mostrarBurbuja(true);
    return;
  }
  setTimeout(abrir, (parseInt(popup.dataset.demora, 10) || 0) * 1000);
}

function vnInitAnuncios() {
  var contenedores = document.querySelectorAll('[data-vn-anuncios]');
  contenedores.forEach(function (contenedor) {
    var mensajes = contenedor.querySelectorAll('.vn-anuncios__mensaje');
    if (mensajes.length < 2) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var velocidad = parseInt(contenedor.getAttribute('data-vn-velocidad'), 10) || 4000;
    var indice = 0;
    setInterval(function () {
      mensajes[indice].classList.remove('vn-anuncios__mensaje--activo');
      indice = (indice + 1) % mensajes.length;
      mensajes[indice].classList.add('vn-anuncios__mensaje--activo');
    }, velocidad);
  });
}

// Alto real del header + barra de anuncios, para que la portada entre justa en la primera pantalla
function vnMedirHeader() {
  var total = 0;
  var raiz = document.documentElement.style;
  document.querySelectorAll('.shopify-section-group-header-group').forEach(function (s) { total += s.offsetHeight; });
  if (total) raiz.setProperty('--vn-alto-header', total + 'px');
  // La portada se mete debajo del header (transparente): necesita el alto del menú y el de la barra de anuncios por separado
  var nav = document.querySelector('.section-header');
  if (nav) raiz.setProperty('--vn-alto-nav', nav.offsetHeight + 'px');
  if (nav && total) raiz.setProperty('--vn-alto-anuncios', (total - nav.offsetHeight) + 'px');
}

// Movimiento ligado al scroll, en un solo bucle con requestAnimationFrame:
// - Portada: queda quieta mientras la sección siguiente sube por encima (--s compensa el scroll,
//   --sp es el avance 0–1); el CSS baja las botellas, desvanece el nombre y aclara la foto.
// - Texto destacado: las palabras se "encienden" a medida que el texto sube.
// - Escenas de producto: arrancan su animación (por tiempo) al entrar en pantalla, y reciben
//   --scroll para un parallax suave.
function vnInitScroll() {
  vnMedirHeader();
  window.addEventListener('resize', vnMedirHeader);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var portadas = document.querySelectorAll('[data-vn-portada]');
  var rellenos = document.querySelectorAll('[data-vn-relleno]');
  var escenas = document.querySelectorAll('[data-vn-escena]');
  if (!portadas.length && !rellenos.length && !escenas.length) return;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    rellenos.forEach(function (t) { t.querySelectorAll('.vn-mani__palabra').forEach(function (w) { w.classList.add('vn-encendida'); }); });
    escenas.forEach(function (e) { e.classList.add('vn-en-escena'); });
    return;
  }

  // Escenas, como la referencia: la animación arranca cuando la sección llega arriba de la pantalla.
  // Si después se scrollea hacia arriba (la sección vuelve a bajar), todo se desvanece enseguida
  // y se reinicia, para volver a caer al bajar de nuevo.
  var esCelular = window.matchMedia('(max-width: 749px)');
  function estadoEscena(e, alto) {
    var r = e.getBoundingClientRect();
    var activa = e.classList.contains('vn-en-escena');
    // En celular la escena es apilada: la botella cae cuando la escena entra en pantalla, y se
    // reinicia solo cuando la escena queda completamente abajo, para volver a caer al bajar de nuevo
    if (esCelular.matches) {
      if (!activa && r.top < alto * 0.7) e.classList.add('vn-en-escena');
      else if (activa && r.top > alto) e.classList.remove('vn-en-escena');
      return;
    }
    var adentro = r.top <= alto * 0.12 && r.bottom > alto * 0.4;
    var pasada = r.bottom <= alto * 0.4;
    if (activa && adentro && e.classList.contains('vn-saliendo')) {
      // Volvió a bajar antes de terminar de desvanecerse: se cancela la salida
      clearTimeout(e._vnSalida);
      e.classList.remove('vn-saliendo');
    } else if (!activa && adentro) {
      clearTimeout(e._vnSalida);
      e.classList.remove('vn-saliendo');
      e.classList.add('vn-en-escena');
    } else if (activa && !adentro && !pasada && !e.classList.contains('vn-saliendo')) {
      e.classList.add('vn-saliendo');
      e._vnSalida = setTimeout(function () {
        e.classList.remove('vn-en-escena', 'vn-saliendo');
      }, 420);
    }
  }

  var pendiente = false;
  function actualizar() {
    pendiente = false;
    var alto = window.innerHeight;

    portadas.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -alto) return;
      var s = Math.max(0, -r.top);
      el.style.setProperty('--s', s.toFixed(1) + 'px');
      el.style.setProperty('--sp', Math.min(1, s / r.height).toFixed(4));
    });

    rellenos.forEach(function (t) {
      var r = t.getBoundingClientRect();
      // Empieza a encenderse cuando el texto entra por abajo y termina cuando llega a un tercio de pantalla
      var p = (alto * 0.9 - r.top) / (alto * 0.9 - alto * 0.3 + r.height * 0.5);
      p = Math.max(0, Math.min(1, p));
      var palabras = t.querySelectorAll('.vn-mani__palabra');
      var hasta = Math.round(p * palabras.length);
      palabras.forEach(function (w, i) { w.classList.toggle('vn-encendida', i < hasta); });
    });

    escenas.forEach(function (e) { estadoEscena(e, alto); });
  }

  function pedir() {
    if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
  }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);
  actualizar();
}

// Lupa: en computadora, al pasar el cursor la foto se amplía en la zona donde está el mouse.
// En celular (sin hover) se mantiene el toque para abrir la foto a pantalla completa.

function vnInitLupa() {
  var conHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!conHover) return;
  document.querySelectorAll('.vn-pp__galeria-principal').forEach(function (marco) {
    var img = marco.querySelector('[data-vn-galeria-principal]');
    if (!img) return;
    var aumento = parseFloat(marco.getAttribute('data-vn-lupa')) || 2.4;

    function srcGrande(src) {
      if (/width=\d+/.test(src)) return src.replace(/width=\d+/, 'width=2400');
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=2400';
    }

    function mover(e) {
      var r = marco.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    // El zoom se activa con un clic sobre la foto (y se desactiva con otro clic o al salir con el mouse)
    var activa = false;
    function activar(e) {
      var grande = srcGrande(img.getAttribute('src'));
      if (img.getAttribute('src') !== grande) img.setAttribute('src', grande);
      mover(e);
      img.style.transform = 'scale(' + aumento + ')';
      marco.classList.add('vn-lupa-activa');
      activa = true;
    }
    function desactivar() {
      img.style.transform = '';
      marco.classList.remove('vn-lupa-activa');
      activa = false;
    }
    marco.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (activa) desactivar(); else activar(e);
    }, true);
    marco.addEventListener('mousemove', function (e) { if (activa) mover(e); });
    marco.addEventListener('mouseleave', desactivar);
  });
}

// Cifras que cuentan al entrar en pantalla. Acepta coma decimal ("0,25").
function vnInitContadores() {
  var els = document.querySelectorAll('[data-vn-contar]');
  if (!els.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) return;

  function animar(el) {
    var original = el.getAttribute('data-vn-contar');
    var objetivo = parseFloat(original.replace(',', '.'));
    if (isNaN(objetivo)) return;
    var partes = original.split(/[.,]/);
    var decimales = partes.length > 1 ? partes[1].length : 0;
    var separador = original.indexOf(',') > -1 ? ',' : '.';
    var duracion = 1600;
    var inicio = null;
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / duracion, 1);
      var suavizado = 1 - Math.pow(1 - p, 3);
      el.textContent = (objetivo * suavizado).toFixed(decimales).replace('.', separador);
      if (p < 1) requestAnimationFrame(paso);
      else el.textContent = original;
    }
    requestAnimationFrame(paso);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animar(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { observer.observe(el); });
}

// "Agregar al carrito" de nuestras secciones: agrega sin recargar y abre el carrito lateral de Dawn.
// Si algo falla (o no hay carrito lateral), deja que el formulario se envíe normal.
function vnInitAgregarAlCarrito() {
  document.querySelectorAll('form[data-vn-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var cajon = document.querySelector('cart-drawer');
      if (!cajon || typeof cajon.renderContents !== 'function' || !window.routes) return;
      e.preventDefault();
      var boton = form.querySelector('[type="submit"]');
      if (boton) boton.setAttribute('aria-busy', 'true');
      var datos = new FormData(form);
      datos.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
      datos.append('sections_url', window.location.pathname);
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: datos
      })
        .then(function (r) { return r.json(); })
        .then(function (respuesta) {
          if (respuesta.status) { form.submit(); return; }
          if (cajon.classList.contains('is-empty')) cajon.classList.remove('is-empty');
          cajon.renderContents(respuesta);
        })
        .catch(function () { form.submit(); })
        .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
    });
  });
}

// Medio de pago en el carrito: un solo botón principal que cambia según la opción elegida.
// Transferencia → acciona el botón (oculto) de la app Scala, que aplica el 10% y deja solo la transferencia.
// Tarjeta/Mercado Pago → checkout normal. La elección se recuerda porque el carrito lateral se redibuja.
function vnInitMedioPago() {
  var CLAVE = 'vnMedioPago';
  function leer() { try { return sessionStorage.getItem(CLAVE) || 'transferencia'; } catch (e) { return 'transferencia'; } }
  function guardar(v) { try { sessionStorage.setItem(CLAVE, v); } catch (e) {} }

  // La barra de envío gratis usa lo que el cliente realmente paga: con transferencia, el total con el 10% OFF
  function actualizarEnvio(eleccion) {
    document.querySelectorAll('[data-vn-envio]').forEach(function (barra) {
      var total = parseInt(barra.getAttribute('data-total'), 10) || 0;
      var umbral = parseInt(barra.getAttribute('data-umbral'), 10) || 0;
      var desc = parseFloat(barra.getAttribute('data-descuento')) || 0;
      if (!umbral) return;
      var efectivo = eleccion === 'transferencia' ? Math.round(total * (1 - desc / 100)) : total;
      var falta = umbral - efectivo;
      var texto = barra.querySelector('[data-vn-envio-texto]');
      var relleno = barra.querySelector('[data-vn-envio-barra]');
      barra.classList.toggle('vn-envio--listo', falta <= 0);
      if (relleno) relleno.style.width = Math.min(100, Math.floor(efectivo * 100 / umbral)) + '%';
      if (texto) {
        texto.innerHTML = falta > 0
          ? 'Te faltan <strong>$' + Math.ceil(falta / 100).toLocaleString('es-AR') + '</strong> para el <strong>envío gratis</strong>'
          : '<strong>¡Tenés envío gratis!</strong>';
      }
    });
  }

  function aplicar(raiz) {
    actualizarEnvio(leer());
    (raiz || document).querySelectorAll('[data-vn-medio-pago]').forEach(function (caja) {
      var eleccion = leer();
      caja.querySelectorAll('[data-vn-pago]').forEach(function (b) {
        var activa = b.getAttribute('data-vn-pago') === eleccion;
        b.classList.toggle('vn-pago__opcion--activa', activa);
        b.setAttribute('aria-checked', activa ? 'true' : 'false');
      });
      var total = caja.querySelector('[data-vn-pago-total]');
      if (total) total.hidden = eleccion !== 'transferencia';
      var contenedor = caja.closest('#CartDrawer, #main-cart-footer') || document;
      if (contenedor.classList) contenedor.classList.toggle('vn-pago-transfer', eleccion === 'transferencia');
      var boton = contenedor.querySelector('button[name="checkout"]');
      if (boton) {
        var texto = eleccion === 'transferencia' ? caja.getAttribute('data-texto-transfer') : caja.getAttribute('data-texto-otro');
        if (boton.textContent.trim() !== texto) boton.textContent = texto;
      }
    });
  }

  document.addEventListener('click', function (e) {
    var opcion = e.target.closest('[data-vn-pago]');
    if (opcion) { guardar(opcion.getAttribute('data-vn-pago')); aplicar(); return; }
    var boton = e.target.closest('button[name="checkout"]');
    if (!boton || leer() !== 'transferencia') return;
    var contenedor = boton.closest('#CartDrawer, #main-cart-footer') || document;
    if (!contenedor.querySelector('[data-vn-medio-pago]')) return;
    var scala = contenedor.querySelector('scala-cart-button') || document.querySelector('scala-cart-button');
    var interno = scala && scala.shadowRoot && scala.shadowRoot.querySelector('#scala-button, button');
    if (!interno) return; // sin la app, sigue el checkout normal
    e.preventDefault();
    e.stopImmediatePropagation();
    boton.setAttribute('aria-busy', 'true');
    interno.click();
  }, true);

  aplicar();
  // El carrito lateral se redibuja después de cada cambio: se vuelve a aplicar la elección
  var cajon = document.querySelector('cart-drawer');
  if (cajon && 'MutationObserver' in window) {
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; aplicar(cajon); });
    }).observe(cajon, { childList: true, subtree: true });
  }
  // El botón de Scala aparece un poco después de cargar
  setTimeout(aplicar, 1500);
}

// Cada sección incluye este archivo con su propio <script>, así que el navegador lo ejecuta
// varias veces por página. La inicialización tiene que correr UNA sola vez: si no, cada
// listener queda registrado N veces (ej.: "Agregar al carrito" sumaba 2–3 unidades por clic).
if (!window.vnIniciado) {
window.vnIniciado = true;
document.addEventListener('DOMContentLoaded', function () {
  vnInitReveals();
  vnInitContadores();
  vnInitLupa();
  vnInitScroll();
  vnInitAgregarAlCarrito();
  vnInitMedioPago();
  vnInitGaleriaProducto();
  vnInitSelectorVariantes();
  vnInitZoomProducto();
  vnInitAnuncios();
  vnInitPopup();
  vnInitFaq();
});
}
